export const TRANSLATIONS_EN_SETTINGS_CORE = {
  "settings.db_connection_title": "Database Connection",
  "settings.db_tables_title": "Database Tables",
  "settings.db_table_name": "Table Name",
  "settings.db_send_selected": "Send selected tables",
  "settings.db_loading": "Processing connection...",
  "settings.db_connect_success": "Database connection successful.",
  "settings.db_connect_error": "Error connecting to the database.",
  "settings.db_not_configured": "Database connection credentials have never been configured.",
  "settings.db_send_success": "Tables sent successfully.",
  "settings.db_send_error": "Error sending tables.",
  "settings.db_tables_error": "Error fetching tables.",
  "settings.db_table_connect_success": "Table connected successfully.",
  "settings.db_table_connect_error": "Error connecting table.",
  "settings.cancel": "Cancel",
  "settings.theme": "Theme",
  "settings.language": "Language",
  "settings.light": "Light",
  "settings.dark": "Dark",
  "settings.spanish": "Spanish",
  "settings.english": "English",
  "settings.portuguese": "Portuguese",
  "settings.french": "French",
  "settings.japanese": "Japanese",
  "settings.title": "Settings",
  "settings.customization": "Customization",
  "settings.company_logo": "Company Logo",
  "settings.logo_placeholder": "Upload your logo here",
  "settings.save": "Save",
  "settings.save_error": "Error saving settings",
  "settings.db_type": "Database Type",
  "settings.db_host": "Host",
  "settings.db_port": "Port",
  "settings.db_user": "User",
  "settings.db_password": "Password",
  "settings.db_name": "Database",
  "settings.select_db_type": "Select...",
  "settings.tab_preferences": "Preferences",
  "settings.tab_bc_email_pooling": "BC Email Pooling",
  "settings.bc_title": "Linked BC Email",
  "settings.bc_create_btn": "Add BC Email",
  "settings.bc_update_btn": "Update BC Email",
  "settings.bc_create_success": "BC Email linked successfully.",
  "settings.bc_create_error": "Error linking BC Email.",
  "settings.bc_update_success": "BC Email updated successfully.",
  "settings.bc_update_error": "Error updating BC Email.",
  "settings.bc_not_configured": "No BC User Binding is configured for this user.",
  "settings.whatsapp_not_configured": "No WhatsApp number has been configured.",
  "settings.tab_email_oauth": "Email OAuth Permission",
  "settings.email_oauth_title": "Email Provider Connection Permission (OAuth)",
  "settings.email_oauth_placeholder":
    "Here you will soon be able to authorize access to your email provider (Gmail, Outlook, etc.).",
  "settings.tab_advanced": "Advanced Settings",
  "settings.advanced_title": "Advanced Settings",
  "settings.penalty_questions": "Penalty Questions",
  "settings.penalty_none": "No penalty",
  "settings.penalty_low": "Low penalty",
  "settings.penalty_medium": "Medium penalty",
  "settings.penalty_high": "High penalty",
  "settings.penalty_questions.header_parameter":
    "Penalty Questions Header Parameter",
  "settings.penalty_questions.header_value": "Penalty Questions Header Value",
  "settings.error_required": "This field is required.",
  "settings.all_types": "All types",
  "settings.select": "Select",
  "settings.edit": "Edit",
  "settings.delete": "Delete",
  "settings.tables": "Tables",
  "settings.search_table": "Search table",
  "settings.no_tables": "No tables available",
  "settings.database": "Database",
  "settings.host": "Host",
  "settings.port": "Port",
  "settings.username": "Username",
  "settings.password": "Password",
  "settings.logo_help": "Upload a logo in PNG or SVG",
  "settings.logo_error": "Error uploading logo",
  "settings.close": "Close",
  "settings.save_success": "Settings saved successfully",
  "settings.bc_email_label": "BC Email",
  "settings.db_delete_success": "DB connection deleted successfully",
  "settings.db_delete_error": "Error deleting DB connection",
  "settings.select_tables": "Select tables",
  "settings.whatsapp_title": "WhatsApp Settings",
  "settings.whatsapp_country_code": "Country code",
  "settings.whatsapp_country_code_placeholder": "Enter country code",
  "settings.whatsapp_country_code_error": "Enter a valid country code",
  "settings.whatsapp_number": "WhatsApp number",
  "settings.whatsapp_number_error": "Invalid number",
  "settings.whatsapp_invalid_number": "Invalid number",
  "settings.whatsapp_invalid_reason_format": "Invalid format",
  "settings.whatsapp_invalid_reason_possible": "Number not possible for the selected country",
  "settings.whatsapp_invalid_reason_valid": "Number not valid",
  "settings.whatsapp_save_btn": "Save",
  "settings.whatsapp_save_success": "WhatsApp number saved",
  "settings.whatsapp_save_error": "Error saving WhatsApp number",
  "settings.whatsapp_update_success": "WhatsApp number updated",
  "settings.whatsapp_update_error": "Error updating WhatsApp number",
  "settings.whatsapp_delete_btn": "Delete",
  "settings.whatsapp_delete_success": "WhatsApp number deleted",
  "settings.whatsapp_delete_error": "Error deleting WhatsApp number",
  "settings.whatsapp_edit_btn": "Edit",
  "settings.whatsapp_configured_number": "Configured number:",
  "settings.tab_google_integrations": "Google Integrations",
  "settings.tab_microsoft_integrations": "Microsoft integrations",
  "settings.reindex.title": "Reindex documents",
  "settings.reindex.description": "Reprocess all your documents in Home IA and Knowledge Hub (reclassification and knowledge extraction). Use it if you changed your rules or want to refresh the analysis. It does not re-upload files.",
  "settings.reindex.button": "Reindex my documents",
  "settings.reindex.confirm": "Yes, reindex",
  "settings.reindex.cancel": "Cancel",
  "settings.reindex.error": "Could not start the reindexing. Please try again.",
  "settings.purge.title": "Delete all my documents",
  "settings.purge.description": "Permanently deletes all your documents (including the files), conversations, classifications and Home IA / Knowledge Hub data. It also disconnects your Google and Microsoft accounts (removing their tokens and sync records), so you will need to reconnect them to sync again. Token usage history is preserved. The cleanup runs in the background and you will receive a notification when it finishes.",
  "settings.purge.button": "Delete all my documents",
  "settings.purge.confirm": "Yes, delete everything",
  "settings.purge.cancel": "Cancel",
  "settings.purge.error": "Could not start the cleanup. Please try again.",
};
